export { default } from './TasksListByOwnerId';



// WEBPACK FOOTER //
// ./src/components/Tasks/ReducerWrappers/TasksListByOwnerId/index.js